import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=34e4e616&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=ts&"
export * from "./Order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4e616",
  null
  
)

export default component.exports